import { useSelector } from 'react-redux';
import { useQuery } from '@tanstack/react-query';

import { queries } from 'api/api.constants';
import { BrandDto, GetBrandResponse } from 'api/repositories/brand/brand.types';

// TODO: 추후 brand fetching하는 로직 모두 정리 후 staleTime, gcTime 조정 필요
const useGetBrand = () => {
  const { auth } = useSelector((state: any) => state.auth);

  return useQuery<GetBrandResponse, Error, BrandDto>({
    ...queries.brand.getBrand({ brandToken: auth.token }),
    enabled: !!auth?.token,
    select: (data) => data.data.brand,
    staleTime: 1000 * 60 * 1, // 1분
    gcTime: 1000 * 60 * 5, // 5분
  });
};

export default useGetBrand;
